import Vue from 'vue';
import Vuex from 'vuex';
import common from './modules/common';
import g020 from './modules/G_kaigai/G_020_JuchuEntry';
import g030 from './modules/G_kaigai/G_030_JuchuToiawase';
import g040 from './modules/G_kaigai/G_040_HatchuConfirm';
import g050 from './modules/G_kaigai/G_050_HassoAnnaiEntry';
import g060 from './modules/G_kaigai/G_060_ShukkaJunbi';
import g070 from './modules/G_kaigai/G_070_HambaiYosokuConfirm';
import g080 from './modules/G_kaigai/G_080_KojoDekidakaEntry';
import g090 from './modules/G_kaigai/G_090_ZaikoIdoIraiEntry';
import g110 from './modules/G_kaigai/G_110_SeikyuList';
import g120 from './modules/G_kaigai/G_120_Home';
import g130 from './modules/G_kaigai/G_130_NohinsakiMstMente';
import g140 from './modules/G_kaigai/G_140_HaisoIrai';
import g150 from './modules/G_kaigai/G_150_HaisoMstMente';
import g160 from './modules/G_kaigai/G_160_HaisoIraiLogi';

Vue.use(Vuex);

const modules = {
  common,
  g020,
  g030,
  g040,
  g050,
  g060,
  g070,
  g080,
  g090,
  g110,
  g120,
  g130,
  g140,
  g150,
  g160,
};

export default new Vuex.Store({
  modules,
});
